import { useState, useEffect, useRef } from "react";
import "./homegalleriemanager.css";
import { toast } from "react-hot-toast";
import API from "src/API2";
import { UPLOAD_URL } from "src/constants";

const AddImagesModal = ({ setActive }) => {
  const [images, setImages] = useState(null);
  const ref = useRef();

  const post = () => {
    const form = new FormData();
    for (let i = 0; i < images.length; i++) {
      form.append("pictures", images[i]);
    }
    toast.promise(
      API.post("content/secondary_slide", form).then(() => {
        window.location.reload();
      }),
      {
        success: "Home gallerie pictures added succeffully",
        error: "Something went wrong",
        loading: "Adding new Home gallerie pictures",
      }
    );
  };

  return (
    <div className="addimagesmodal">
      <div className="wrapperblur">
        <div className="content">
          <div className="image_input">
            {images ? (
              Array.from(images)
                .slice(0, 9)
                .map((e, i) => {
                  return (
                    <img
                      key={i}
                      src={URL.createObjectURL(images[i])}
                      className="left"
                      alt="Preview"
                    />
                  );
                })
            ) : (
              <div className="left"></div>
            )}
            {images?.length > 9 ? (
              <div className="more_images">
                {images.length - 9} more images ...
              </div>
            ) : (
              <></>
            )}
            <div className="right">
              <span>Select the gallerie pictures</span>
              <div
                className="full_button"
                onClick={() => {
                  ref.current.click();
                }}
              >
                Browse
              </div>
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              ref={ref}
              multiple="multiple"
              onChange={(e) => {
                setImages(e.target.files);
              }}
            />
          </div>
          <div className="buttons">
            <div
              className="outlined_button"
              onClick={() => {
                setActive(false);
              }}
            >
              Cancel
            </div>
            <div
              className="full_button"
              onClick={() => {
                post();
              }}
            >
              Create
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomeGallerieManager = () => {
  const [active, setActive] = useState(false);
  const [homeGallerieImages, setHomeGallerieImages] = useState([]);



  useEffect(() => {
    toast.promise(
      API.get("content/secondary_slide").then((resp) => {
        setHomeGallerieImages(resp.data.secondarySlides);
      }),
      {
        success: "Home gallerie pictures fetched succeffully.",
        error: "Something went wrong.",
        loading: "Fetching Home gallerie pictures.",
      }
    );
  }, []);
  return (
    <div className="galleriemanager">
      {active && <AddImagesModal setActive={setActive} />}
      <div className="pictures">
        <div className="top">
          <h3>Home Gallerie</h3>
          <div
            className="full_button"
            onClick={() => {
              setActive(true);
            }}
          >
            Add new pictures
          </div>
        </div>
        <div className="hotel_room">
          <div className="group_pictures">
            {homeGallerieImages.length ? (
              homeGallerieImages.map((e, i) => {
                return (
                  <div
                    key={i}
                    className="img"
                    onDoubleClick={() => {
                      toast.promise(
                        API.delete("content/secondary_slide/" + e.id).then(() => {
                          setHomeGallerieImages((prev) =>
                            prev.filter((k) => k.id !== e.id)
                          );
                        }),
                        {
                          success: "Picture deleted succeffuly.",
                          error: "something went wrong.",
                          loading: "Deleting Picutre.",
                        }
                      );
                    }}
                  >
                    <img
                      key={i}
                      src={UPLOAD_URL[process.env.NODE_ENV] + e.picture.filename}
                      alt="Home gallerie"
                    />
                  </div>
                );
              })
            ) : (
              <div className="dump_img"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeGallerieManager;
